import { useEffect, useState } from "react";
import StudioAnalyticsSection from "../../../components/midpoint/clientViews/studio/StudioAnalyticsSection";
import CasaMapaAdminAnalyticsSectionShell from "../../../components/casamapa/admin/CasaMapaAdminAnalyticsSectionShell";
import {
  casaMapaAdminClientViewAnalyticsApi,
  getCasaMapaAdminGa4AnalyticsStatus,
} from "../../../api/clientCasamapaAdminAnalyticsApi";
import { useCasaMapaAdminPortal } from "../../../hooks/useCasaMapaAdminPortal";
import { useLocale } from "../../../intl";
import "../../../styles/clientViewStudio.css";

export default function CasaMapaAdminWebsiteAnalyticsPage() {
  const { clientViewId } = useCasaMapaAdminPortal();
  const { t } = useLocale();
  const [apiError, setApiError] = useState("");

  useEffect(() => {
    if (!clientViewId) {
      return undefined;
    }

    let cancelled = false;
    getCasaMapaAdminGa4AnalyticsStatus(clientViewId)
      .then(() => {
        if (!cancelled) {
          setApiError("");
        }
      })
      .catch((error) => {
        if (!cancelled) {
          setApiError(error.message || t("realEstate.casaMapa.admin.analytics.errors.load"));
        }
      });

    return () => {
      cancelled = true;
    };
  }, [clientViewId, t]);

  if (!clientViewId) {
    return (
      <CasaMapaAdminAnalyticsSectionShell introKey="realEstate.casaMapa.admin.errors.noViewMessage">
        <p className="muted">{t("realEstate.casaMapa.admin.errors.noViewMessage")}</p>
      </CasaMapaAdminAnalyticsSectionShell>
    );
  }

  return (
    <CasaMapaAdminAnalyticsSectionShell
      introKey="realEstate.casaMapa.admin.analytics.website.subtitle"
      className="cm-admin-analytics__section--website"
    >
      {apiError ? (
        <div className="cm-admin-analytics__api-error" role="alert">
          <strong>{t("realEstate.casaMapa.admin.analytics.errors.apiUnavailableTitle")}</strong>
          <p>{apiError}</p>
          <p className="muted">{t("realEstate.casaMapa.admin.analytics.errors.apiUnavailableHint")}</p>
        </div>
      ) : null}

      <StudioAnalyticsSection
        clientViewId={clientViewId}
        disabled
        analyticsApi={casaMapaAdminClientViewAnalyticsApi}
        initialDataSource="combined"
        visibleTabIds={["traffic", "engagement"]}
      />
    </CasaMapaAdminAnalyticsSectionShell>
  );
}
